import BenchlingConfig from 'BenchlingConfig';

export function shouldDisablePrimaryLinkColumn(): boolean {
  return (
    BenchlingConfig.ELN_ENABLE_INSERT_NEW_RESULTS_TABLE &&
    BenchlingConfig.RESULTS_ENABLE_RESULTS_AGAINST_CONTAINERS_FEATURES
  );
}
